
/**
 * MODAL DE CONFIRMATION POUR LES ACTIONS DE FACTURATION
 */
const ConfirmationModal = ({ 
  show, 
  type, 
  facturation, 
  message, 
  onConfirm, 
  onCancel,
  loading = false,
  t 
}) => {
  if (!show) return null;

  const getModalConfig = () => {
    const configs = {
      validate: {
        title: t('modals.confirmation.titles.validate'),
        icon: 'fas fa-check-circle text-primary',
        confirmButton: 'btn-primary',
        confirmText: t('modals.confirmation.actions.validate'),
        loadingText: t('modals.confirmation.actions.loading.validate')
      },
      commission: {
        title: t('modals.confirmation.titles.commission'),
        icon: 'fas fa-credit-card text-warning',
        confirmButton: 'btn-warning',
        confirmText: t('modals.confirmation.actions.commission'),
        loadingText: t('modals.confirmation.actions.loading.commission')
      },
      final: {
        title: t('modals.confirmation.titles.final'),
        icon: 'fas fa-money-bill-wave text-success',
        confirmButton: 'btn-success',
        confirmText: t('modals.confirmation.actions.final'),
        loadingText: t('modals.confirmation.actions.loading.final')
      }
    };
    
    return configs[type] || configs.validate;
  };

  const config = getModalConfig();

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg">
          {/* En-tête */}
          <div className="modal-header border-0 pb-0">
            <div className="d-flex align-items-center">
              <i className={`${config.icon} fa-2x me-3`}></i>
              <h5 className="modal-title fw-bold">{config.title}</h5>
            </div>
            <button 
              type="button" 
              className="btn-close" 
              onClick={onCancel}
              disabled={loading}
            ></button>
          </div>

          {/* Corps */}
          <div className="modal-body py-4">
            <div className="alert alert-info border-0 bg-light">
              <div className="d-flex">
                <i className="fas fa-info-circle text-info me-2 mt-1"></i>
                <div>
                  <strong>{t('modals.confirmation.messages.info', { id: facturation?.id })}</strong>
                  <br />
                  <span className="text-muted">{facturation?.accountName}</span>
                </div>
              </div>
            </div>
            
            <div className="mb-3">
              <p className="mb-0 text-dark" style={{ whiteSpace: 'pre-line' }}>
                {message}
              </p>
            </div>

            <div className="alert alert-warning border-0 bg-warning bg-opacity-10 small">
              <i className="fas fa-exclamation-triangle text-warning me-2"></i>
              {t('modals.confirmation.messages.warning')}
            </div>
          </div>

          {/* Pied de page */}
          <div className="modal-footer border-0 pt-0">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onCancel}
              disabled={loading}
            >
              <i className="fas fa-times me-2"></i>
              {t('modals.confirmation.actions.cancel')}
            </button>
            
            <button
              type="button"
              className={`btn ${config.confirmButton} d-flex align-items-center`}
              onClick={onConfirm}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                  {config.loadingText}
                </>
              ) : (
                <>
                  <i className="fas fa-check me-2"></i>
                  {config.confirmText}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;